import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeURI'
})
export class DecodeURIPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return decodeURIComponent(value);
  }

}
